import { Typo3ButtonNew } from '@/types/typo3'
import { Typo3TitleLayout } from '@/types/typo3/utils'
import { Button, Container, Eyebrow, Title } from '@/ui/components'
import { TitleProps } from '@/ui/components/Base/Title'
import { getTitleTag } from '@/utils'
import { memo } from 'react'

export interface SectionHeaderProps {
  titleLayout?: Typo3TitleLayout
  title?: string
  overline?: string
  buttons?: Typo3ButtonNew[]
  mode?: 'default' | 'invert'
  as?: TitleProps['as']
}

const SectionHeader = ({
  titleLayout,
  overline,
  title,
  buttons,
  mode,
  as
}: SectionHeaderProps) => {
  if ((!title && !overline && !buttons) || titleLayout === '100') {
    return null
  }

  const titleTag = as ? as : titleLayout ? getTitleTag(titleLayout) : 'h2'

  return (
    <Container anim="fade-in">
      <header>
        <Eyebrow mode={mode}>{overline}</Eyebrow>
        <Title as={titleTag} className={titleTag}>
          {title}
        </Title>
        {buttons && buttons?.length > 0 && (
          <div className="gap-gutter flex items-center">
            {buttons.map((button, index) => (
              <Button
                key={index?.toString()}
                {...button}
                mode={button?.mode || mode}
              />
            ))}
          </div>
        )}
      </header>
    </Container>
  )
}

SectionHeader.displayName = 'SectionHeader'

export default memo(SectionHeader)
